@if (isActive) {
<div class="overlay">
    <div class="container">
        <h2 i18n>Zgoda na pliki cookie</h2>
        <div class="wrapper">
            <p i18n>Cookies to małe pliki danych, które są przechowywane na Twoim urządzeniu podczas przeglądania stron
                internetowych. Używamy ich do poprawy działania serwisu, personalizacji treści, oraz analizy ruchu na
                stronie.</p>
            <form [formGroup]="cookieForm">
                @for (category of cookieCategories; track category; let i = $index) {
                <div class="category">
                    <div class="checkbox-container">
                        <input type="checkbox" [checked]="category.isRequired" [formControlName]="category.setting"
                            [name]="category.setting">
                        <label [for]="category.setting">{{category.label}}</label>
                    </div>
                    <p>{{category.description}}</p>
                    @if(category.cookiesList.length > 0) {
                    <div class="expand-container" (click)="toggleCategory(i)">
                        <button class="expand">
                            @if (expandedCategoryIndex === i) {
                            <span i18n>Zwiń</span>
                            } @else {
                            <span i18n>Rozwiń</span>
                            }
                        </button>
                        <mat-icon>keyboard_arrow_down</mat-icon>
                    </div>
                    }
                </div>
                <div class="cookie-details" [@open]="expandedCategoryIndex === i ? 'in' : 'out'">
                    @for (cookie of category.cookiesList; track $index) {
                    <div class="cookie">
                        <div class="name">
                            {{cookie.name}}
                        </div>
                        <div class="description">
                            <p [class.no-border]="!cookie.data">{{cookie.description}}</p>
                            @if (cookie.data) {
                            <strong><span i18n>Data ważności:</span> {{cookie.data}}</strong>
                            }
                        </div>
                    </div>
                    }
                </div>
                }
            </form>
        </div>
        <div class="buttons">
            <button (click)="declineAllCookies()" class="customize" i18n>Odrzuć wszystkie</button>
            <button (click)="acceptSelected()" class="customize" i18n>Zezwól na wybrane</button>
            <button (click)="acceptAllCookies()" class="accept" i18n>Zezwól na wszystkie</button>
        </div>
    </div>
</div>
}
